import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      alertDetail: {
        BACK_TO_ALERT_LIST: 'Back to Alert List',
        MACROECONOMIC: 'Macroeconomics',
        TRIGGER_DATE: 'Trigger Date',
        PORTFOLIOS: 'Portfolios',
        TOTAL_PORTFOLIOS: 'Total Portfolios',
        PORTFOLIO_NAME: 'Portfolio name',
        PROFILE_NAME: 'Profile name',
        PORTFOLIO_TRIGGER: 'Portfolio trigger',
        ALERT_FOR: 'Alerts for ',
        ALERT_FOR_COMPANY_NOTE:
          'Review previous alerts for this company to see a full picture of recent changes.',
        TOTAL_ALERTS: 'Total Alerts',
        STT: '#',
        TYPE: 'Type / Description',
        DATE: 'Date',
        PORTFOLIO: 'Portfolio',
        TRIGGER: 'Trigger',
        CLICK_HERE: 'Click here',
        FOR_MORE_INFORMATION: 'for more information.',
        FROM_COMPANY_INCOME_STATEMENT:
          "are from the Company's Income Statement",
        SENTIMENT: 'Sentiment',
        SOURCE: 'Source',
        EVENT: 'Event',
        PUBLICATION_DATE: 'Publication Date',
        LINK_ARTICLE: 'Article link',
        PREVIOUS: 'Previous',
        CURRENT: 'Current',
        FIINGROUP_PREDICTIVE_MODEL: "FIINGROUP'S PREDICTIVE MODEL",
        FIINGROUP_PREDICTIVE_MODEL_NOTE:
          "FiinGroup's Predictive Models provide customers with insightful analytics into how an organization is likely to perform in the future. Our Models combine sophisticated machine learning algorithms with a large Vietnamese enterprise database. By identifying late payments and high-risk organizations, we assist customers in making decisions that drive growth, mitigate risk, and increase profitability.",
        BUY_SCORE_INFORMATION: 'Buy Score Infomation',
        VIEW_MORE: 'View more',
        NAME: 'Name',
        POSITION: 'Position',
        SHAREHOLDING: 'Shareholding',
        PERCENTAGE: 'Percentage',
        COUNTRY: 'Country',
        FISCAL_YEAR: 'Fiscal Year End Date',
        financialType: {
          PROFIT_BEFORE_TAX: 'Profit before tax',
          REVENUE: 'Revenue',
          OPERATING_INCOME: 'Operating Income',
        },
        OVERDUE_TAXT_DEBT_CONTENT:
          'The company has an <b>Overdue Tax Debt</b> and may be required to report it to registered credit reporting bureaus.',
        OVERDUE_TAXT_DEBT_VIEW:
          "to view the company's Overdue Tax Debt history.",
        OVERDUE_SOCIAL_INSURANCE_CONTENT:
          'The company has <b>Overdue Social Insurance</b> and may be required to report such tax liability to registered credit reporting bureaus.',
        OVERDUE_SOCIAL_INSURANCE_VIEW:
          "to view the company's Overdue Social Insurance history.",
        INVOICE_ENFORCEMENT_CONTENT:
          'The company has an <b>Enforced Invoice</b>.',
        INVOICE_ENFORCEMENT_VIEW:
          "to view the company's enforce invoice history.",
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      alertDetail: {
        BACK_TO_ALERT_LIST: 'Trở về Danh sách cảnh báo',
        MACROECONOMIC: 'Kinh tế vĩ mô',
        TRIGGER_DATE: 'Ngày cảnh báo',
        PORTFOLIOS: 'Danh mục',
        TOTAL_PORTFOLIOS: 'Tổng danh mục',
        PORTFOLIO_NAME: 'Tên danh mục',
        PROFILE_NAME: 'Tên quy tắc',
        PORTFOLIO_TRIGGER: 'Danh mục cảnh báo',
        ALERT_FOR: 'Cảnh báo của ',
        ALERT_FOR_COMPANY_NOTE:
          'Xem lại các cảnh báo cho công ty này để xem bức tranh toàn cảnh về những thay đổi gần đây.',
        TOTAL_ALERTS: 'Tổng số cảnh báo',
        STT: '#',
        TYPE: 'Phân loại / Mô tả ',
        DATE: 'Ngày',
        PORTFOLIO: 'Danh mục',
        TRIGGER: 'Tập Cảnh Báo',
        CLICK_HERE: 'Nhấp vào đây',
        FOR_MORE_INFORMATION: 'để xem thêm thông tin.',
        FROM_COMPANY_INCOME_STATEMENT:
          'được lấy từ báo cáo kết quả hoạt động kinh doanh của doanh nghiệp',
        SENTIMENT: 'Trạng Thái',
        SOURCE: 'Nguồn',
        EVENT: 'Sự kiện',
        PUBLICATION_DATE: 'Ngày Phát Hành',
        LINK_ARTICLE: 'Liên kết bài viết',
        PREVIOUS: 'Trước',
        CURRENT: 'Hiện tại',
        FIINGROUP_PREDICTIVE_MODEL: 'MÔ HÌNH DỰ BÁO - CHẤM ĐIỂM DOANH NGHIỆP',
        FIINGROUP_PREDICTIVE_MODEL_NOTE:
          'Mô hình của chúng tôi là sự kết hợp của các thuật toán machine-learning phức tạp và cơ sở dữ liệu toàn diện về các doanh nghiệp Việt Nam. Bằng cách phát hiện các doanh nghiệp thanh toán trễ và có rủi ro cao, chúng tôi hỗ trợ khách hàng đưa ra các quyết định giảm thiểu rủi ro, thúc đẩy tăng trưởng và tăng khả năng sinh lời.',
        BUY_SCORE_INFORMATION: 'Mua thông tin điểm',
        VIEW_MORE: 'Xem thêm',
        NAME: 'Tên',
        POSITION: 'Vị trí',
        SHAREHOLDING: 'Tỉ lệ sở hữu',
        PERCENTAGE: 'Tỉ lệ sở hữu',
        COUNTRY: 'Quốc gia',
        FISCAL_YEAR: 'Ngày kết thúc năm tài chính',
        financialType: {
          PROFIT_BEFORE_TAX: 'Lợi nhuận trước thuế',
          REVENUE: 'Doanh thu',
          OPERATING_INCOME: 'Thu nhập hoạt động',
        },
        OVERDUE_TAXT_DEBT_CONTENT:
          'Công ty nợ thuế quá hạn và phải báo cáo nghĩa vụ nợ thuế cho cơ quan có thẩm quyền liên quan.',
        OVERDUE_TAXT_DEBT_VIEW: 'để xem lịch sử quá hạn nợ thuế của công ty.',
        OVERDUE_SOCIAL_INSURANCE_CONTENT:
          'Công ty có bảo hiểm xã hội quá hạn và có thể phải báo cáo nghĩa vụ nợ cho cơ quan có thẩm quyền liên quan.',
        OVERDUE_SOCIAL_INSURANCE_VIEW:
          'để xem lịch sử quá hạn bảo hiểm xã hội của công ty.',
        INVOICE_ENFORCEMENT_CONTENT: 'Công ty có hóa đơn cưỡng chế.',
        INVOICE_ENFORCEMENT_VIEW:
          'để xem lịch sử cưỡng chế hóa đơn của công ty.',
      },
    },
  }),
)
